import api from 'utils/api';

export const getContractedProducts = currentCompanyId =>
  api.getWithWrapper(`/v1/contracts/summary?company=${currentCompanyId}`);

export const getRevenueSummary = () =>
  api.getWithWrapper('/v1/revenue/summary');

export const getNewsFeed = () => api.getWithWrapper('/v1/news');
